import { apiRequest, buildQuery } from "./api-client";

export const jobService = {
    list(params) {
        return apiRequest(`/jobs${buildQuery(params)}`);
    },
    get(id) {
        return apiRequest(`/jobs/${id}`);
    },
    preview(id) {
        return apiRequest(`/jobs/${id}/preview`);
    },
    apply(id, coverLetter = "") {
        return apiRequest(`/jobs/${id}/apply`, {
            method: "POST",
            body: { coverLetter }
        });
    },
    save(id) {
        return apiRequest(`/jobs/${id}/save`, {
            method: "POST"
        });
    },
    unsave(id) {
        return apiRequest(`/jobs/${id}/save`, {
            method: "DELETE"
        });
    },
    companies(params = {}) {
        return apiRequest(`/companies${buildQuery(params)}`);
    },
    candidates(params = {}) {
        return apiRequest(`/candidates${buildQuery(params)}`);
    },
    company(id) {
        return apiRequest(`/companies/${id}`);
    },
    myApplications() {
        return apiRequest("/me/applications");
    },
    mySavedJobs() {
        return apiRequest("/me/saved-jobs");
    },
    employerJobs() {
        return apiRequest("/employer/jobs");
    },
    employerJobViews(jobId) {
        return apiRequest(`/employer/jobs/${jobId}/views`);
    },
    employerApplications(params = {}) {
        return apiRequest(`/employer/applications${buildQuery(params)}`);
    },
    updateApplication(id, payload) {
        return apiRequest(`/employer/applications/${id}`, {
            method: "PATCH",
            body: payload
        });
    },
    applicationMessages(id) {
        return apiRequest(`/applications/${id}/messages`);
    },
    sendApplicationMessage(id, message) {
        return apiRequest(`/applications/${id}/messages`, {
            method: "POST",
            body: { message }
        });
    },
    createEmployerJob(payload) {
        return apiRequest("/employer/jobs", {
            method: "POST",
            body: payload
        });
    },
    updateEmployerJob(id, payload) {
        return apiRequest(`/employer/jobs/${id}`, {
            method: "PATCH",
            body: payload
        });
    },
    deleteEmployerJob(id) {
        return apiRequest(`/employer/jobs/${id}`, {
            method: "DELETE"
        });
    },
    employerCompany() {
        return apiRequest("/employer/company");
    },
    saveEmployerCompany(payload) {
        return apiRequest("/employer/company", {
            method: payload?.id ? "PATCH" : "POST",
            body: payload
        });
    },
    updateEmployerCompany(id, payload) {
        return apiRequest(`/employer/companies/${id}`, {
            method: "PATCH",
            body: payload
        });
    },
    uploadCompanyLogo(file) {
        return uploadFile("/employer/company/logo", file);
    },
    uploadCompanyBanner(file) {
        return uploadFile("/employer/company/banner", file);
    },
    uploadEmployerCompanyLogo(id, file) {
        return uploadFile(`/employer/companies/${id}/logo`, file);
    },
    uploadEmployerCompanyBanner(id, file) {
        return uploadFile(`/employer/companies/${id}/banner`, file);
    },
    uploadJobImage(id, file) {
        return uploadFile(`/employer/jobs/${id}/image`, file);
    },
    uploadJobPoster(id, file) {
        return uploadFile(`/employer/jobs/${id}/poster`, file);
    },
    resumes() {
        return apiRequest("/me/resumes");
    },
    uploadResume(file) {
        const formData = new FormData();
        formData.set("file", file);
        return apiRequest("/me/resumes", {
            method: "POST",
            body: formData
        });
    },
    deleteResume(id) {
        return apiRequest(`/me/resumes/${id}`, {
            method: "DELETE"
        });
    },
    blogs(params = {}) {
        return apiRequest(`/blogs${buildQuery(params)}`);
    },
    blog(id) {
        return apiRequest(`/blogs/${id}`);
    },
    blogCategories() {
        return apiRequest("/blog-categories");
    },
    adminCreateBlogCategory(payload) {
        return apiRequest("/admin/blog-categories", {
            method: "POST",
            body: payload
        });
    },
    adminDeleteBlogCategory(id) {
        return apiRequest(`/admin/blog-categories/${id}`, {
            method: "DELETE"
        });
    },
    adminCreateBlogPost(payload) {
        return apiRequest("/admin/blogs", {
            method: "POST",
            body: payload
        });
    },
    adminUpdateBlogPost(id, payload) {
        return apiRequest(`/admin/blogs/${id}`, {
            method: "PATCH",
            body: payload
        });
    },
    adminDeleteBlogPost(id) {
        return apiRequest(`/admin/blogs/${id}`, {
            method: "DELETE"
        });
    },
    adminUploadBlogImage(id, file) {
        return uploadFile(`/admin/blogs/${id}/featured-image`, file);
    },
    jobCategories() {
        return apiRequest("/job-categories");
    },
    adminJobCategories() {
        return apiRequest("/admin/job-categories");
    },
    adminCreateJobCategory(payload) {
        return apiRequest("/admin/job-categories", {
            method: "POST",
            body: payload
        });
    },
    adminDeleteJobCategory(id) {
        return apiRequest(`/admin/job-categories/${id}`, {
            method: "DELETE"
        });
    }
};

function uploadFile(path, file) {
    const formData = new FormData();
    formData.set("file", file);
    return apiRequest(path, {
        method: "POST",
        body: formData
    });
}
